// src/pages/ContactUs.jsx
import React from "react";
import bannerImg from "../assets/contact-bannere.webp";
import { FiPhone, FiMail, FiMapPin } from "react-icons/fi";
import "../App.css";

import { Helmet } from "react-helmet";
const ContactUs = () => {
  return (
    
    <div className="contact-page">
<Helmet>
  <title>Contact Slimline Hardware | Kitchen Hardware Supplier</title>
  <meta name="description" content="Get in touch with Slimline Hardware for modular kitchen accessories and cabinet fittings." />
  <meta name="keywords" content="contact kitchen hardware, Slimline Hardware contact, modular kitchen supplier" />
</Helmet>
      {/* ===== BANNER ===== */}
      <section className="contact-banner">
        <img src={bannerImg} alt="Contact Banner" loading="lazy" />
        <div className="contact-banner-overlay">
          <h1>CONTACT US</h1>
        </div>
      </section>

      {/* ===== MAP + FORM SECTION ===== */}
      <section className="contact-map-form-section">
        <div className="contact-map-form-container">

          {/* MAP - LEFT */}
          <div className="contact-map">
            <iframe
              title="Office Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3500.2874682720003!2d76.9562409!3d28.6810462!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d0ed0fcf05111%3A0xf558bcc00a860747!2s1289%2C%20MIE%20Part-B%2C%20Bahadurgarh%2C%20Haryana%20124507!5e0!3m2!1sen!2sin!4v1773210817365!5m2!1sen!2sin"
              loading="lazy"
            ></iframe>
          </div>



          {/* FORM - RIGHT */}
          <div className="contact-form-box">
            <h2>Get In Touch</h2>
            <p>Please fill the form and we will contact you shortly.</p>

            <form className="contact-form">
              <div className="form-row">
                <input type="text" placeholder="Your Name" required />
                <input type="email" placeholder="Email Address" required />
              </div>

              <input type="text" placeholder="Phone Number" required />
              <textarea placeholder="Your Message"></textarea>

              <button type="submit">Send Message</button>
            </form>
          </div>

        </div>
      </section>


<div className="contact-section">

  {/* PHONE */}
  <div className="contact-card">
    <FiPhone className="contact-icon"/>

    <h3>Contact Phone Number</h3>

    <p>
      Landline: 
      <a href="tel:+91 9650100908"> +91 9650100908</a>
    </p>

    <p>
      Mobile: 
      <a href="tel:+91 9650100908"> +91 9650100908</a>
    </p>
  </div>


  {/* EMAIL */}
  <div className="contact-card">
    <FiMail className="contact-icon"/>

    <h3>Our Email Address</h3>

    <p>
      <a href="mailto:info@slimlinekitchens.com">
        info@slimlinekitchens.com
        {/* www.slimlinekitchens.com 
        www.slimlinehardware.com */}
      </a>
    </p>
  </div>


  {/* LOCATION */}
  <div className="contact-card">
    <FiMapPin className="contact-icon"/>

    <h3>Our Location</h3>

    <p>1289 MIE PART - B BAHADURGARH HARYANA </p>
    <p>HARYANA India (124507)</p>
  </div>

</div>
    </div>
  );
};

export default ContactUs;
